const BR_TAG = /<br\s*\/?>/gi;

const NBSP = '\u00A0';

/**
 * Encje spacji twardej z CMS/HTML → prawdziwy znak NBSP (nie widoczny tekst „&nbsp;”).
 * Obsługa zwykłej i podwójnie escapowanej (`&amp;nbsp;`).
 */
export function decodeNbspEntities(text: string): string {
  return text
    .replace(/&amp;#x0*a0\s*;/gi, NBSP)
    .replace(/&amp;#160\s*;/gi, NBSP)
    .replace(/&amp;nbsp;/gi, NBSP)
    .replace(/&#x0*a0\s*;/gi, NBSP)
    .replace(/&#160\s*;/gi, NBSP)
    .replace(/&nbsp;/gi, NBSP);
}

/** Zamienia tagi `<br>` na `\n`, potem dzieli po znakach nowej linii (bez HTML). */
export function splitTextByLineBreaks(text: string): string[] {
  return decodeNbspEntities(text).replace(BR_TAG, '\n').split('\n');
}

export function stripBrTags(text: string | undefined | null): string {
  return (text ?? '')
    .replace(BR_TAG, ' ')
    .replace(/\s{2,}/g, ' ')
    .trim();
}
